<app-header1></app-header1>
<div class="wel-main">
  <div class="container-fuild banner">
    <!-- <video src="https://cdn.virtueanalytics.com/cache/top5-colleges-student-banner.mp4" width="100%" height="300px"></video> -->
    <div
      class="container d-flex flex-lg-row flex-sm-column flex-column justify-content-center align-items-center"
    >
      <div class="w-50 w-md-75">
        <div class="">
          <div class="">
            <!-- <div class="d-flex flex-row justify-content-start mb-2 ">
              <h1 class="">Top5 Colleges</h1>
            </div> -->
            <p>
              The Top5 Colleges tool provides college aspiring students and
              their families with a tabulated comparison of scholarships
              available for their choice of colleges.
              <span>Choose Wisely! </span>
            </p>
          </div>
        </div>
      </div>
      <div class="w-50">
        <div class="d-flex flex-row justify-content-around">
          <div class="bg-white student-login main">
            <div class="Signup">
              <div
                class="text-center pb-3 border-b mb-3 border-gray-200 d-flex flex-row justify-content-between"
              >
                <!-- <tui-tabs style="box-shadow: none !important"> -->
                <button class="tabs" style="color: #f2692e !important" tuiTab>
                  Reset your password
                </button>
                <!-- </tui-tabs> -->
                <div *ngIf="isAccountcheckDropdown" style="width: 30px">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-2 h-2 mr-2"
                    (click)="back()"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                    />
                  </svg>
                </div>
              </div>
              <section class="mt-4">
                <form
                  *ngIf="!isAccountcheckDropdown"
                  #forgetForm="ngForm"
                  autocomplete="false"
                  (ngSubmit)="onClickSendRequest(forgetForm)"
                >
                  <div style="display: flex" class="maincheckdiv relative">
                    <div class="inputcheckvalue">
                      <input
                        [checked]="showUsernameInput"
                        type="radio"
                        style="position: relative; top: 2px"
                        name="username"
                        (change)="onCheckboxChange(true)"
                      />
                      <span> Username </span>
                    </div>
                    <div class="inputcheckvalue ml-3 mb-4">
                      <input
                        type="radio"
                        style="position: relative; top: 2px"
                        name="username"
                        (change)="onCheckboxChange(false)"
                        [checked]="!showUsernameInput"
                      />
                      <span> Email Id</span>
                    </div>
                  </div>
                  <div *ngIf="showUsernameInput" class="form-group fm-row">
                    <label class="block text-gray-700 font-bold" for="username">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class=""
                        style="width: 1.5rem; margin-right: 0.5rem"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>

                      Username</label
                    >
                    <input type="text" [(ngModel)]="username" name="username" />
                    <!-- <label>
                      Username:
                      <input type="text" [(ngModel)]="usernameInput" />
                    </label> -->
                  </div>

                  <div *ngIf="!showUsernameInput" class="form-group fm-row">
                    <label class="block text-gray-700 font-bold" for="username">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class=""
                        style="width: 1.5rem; margin-right: 0.5rem"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>

                      Email</label
                    >
                    <input
                      type="text"
                      id="email"
                      [(ngModel)]="email"
                      name="email"
                      (ngModelChange)="onInputChange($event)"
                    />
                    <!-- (ngModelChange)="onInputChange($event)" -->
                    <!-- <label>
                      Email:
                      <input type="email" [(ngModel)]="emailInput" />
                    </label> -->
                    <!-- [disabled]="
                    forgotPasswordForm.value.email === '' &&
                    forgotPasswordForm.value.username === ''
                  "
                  [ngClass]="
                    forgotPasswordForm.value.email === '' &&
                    forgotPasswordForm.value.username === ''
                      ? 'send-request'
                      : ''
                  " -->
                  </div>
                  <tui-loader
                    class="loader"
                    [inheritColor]="true"
                    [overlay]="true"
                    [showLoader]="isLoadingRequest"
                  >
                    <button
                      class="btn btn-primary page-btn mt-4"
                      tuiButton
                      type="submit"
                    >
                      {{ Proceed }}
                    </button>
                  </tui-loader>
                  <!-- <button
                    type="submit"
                    tuiButton
                    type="submit"
                    class="btn btn-primary"
                  >
                    {{ Proceed }}
                    <tui-root>
                      <ng-container *ngIf="isLoadingRequest">
                        <tui-loader
                          [inheritColor]="true"
                          [style.height.px]="30"
                          [style.width.px]="30"
                        >
                        </tui-loader>
                      </ng-container>
                    </tui-root>
                  </button> -->
                </form>
                <div
                  *ngIf="isAccountcheckDropdown"
                  class="mt-3 form-group fm-row"
                >
                  <label>Organization Name</label>
                  <select
                    [(ngModel)]="selectdropdown"
                    (change)="onDropdownChange($event)"
                    name="selectdropdown"
                  >
                    <option
                      *ngFor="let option of Accountchecker"
                      [value]="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <button
                  *ngIf="isAccountcheckDropdown"
                  type="submit"
                  tuiButton
                  type="submit"
                  class="btn btn-primary page-btn mt-4"
                  (click)="sendRequestMultiple()"
                >
                  Send Request
                </button>

                <!-- <div class="form-group fm-row">
                  <form [formGroup]="forgotPasswordForm">
                    <label class="block text-gray-700 font-bold" for="username">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class=""
                        style="width: 1.5rem; margin-right: 0.5rem"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>

                      Username</label
                    >
                    <input type="text" id="email" formControlName="username" />
                    <div class="d-flex flex-row justify-content-center mt-2">
                      OR
                    </div>
                    <label class="block text-gray-700 font-bold" for="username">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class=""
                        style="width: 1.5rem; margin-right: 0.5rem"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>

                      Email</label
                    >
                    <input
                      type="text"
                      id="email"
                      formControlName="email"
                      [ngClass]="
                        forgotPasswordForm.value.email === '' && isValidField
                          ? 'border-error'
                          : ''
                      "
                      (ngModelChange)="onInputChange($event)"
                    />
                    <div *ngIf="isAccountcheckDropdown" class="mt-3">
                      <label>Organization Name</label>
                      <select
                        [(ngModel)]="selectdropdown"
                        (change)="onDropdownChange($event)"
                        [ngModelOptions]="{ standalone: true }"
                      >
                        <option
                          *ngFor="let option of Accountchecker"
                          [value]="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <button
                      [disabled]="
                        forgotPasswordForm.value.email === '' &&
                        forgotPasswordForm.value.username === ''
                      "
                      [ngClass]="
                        forgotPasswordForm.value.email === '' &&
                        forgotPasswordForm.value.username === ''
                          ? 'send-request'
                          : ''
                      "
                      type="submit"
                      tuiButton
                      type="submit"
                      class="btn btn-primary page-btn mt-4"
                      (click)="onClickSendRequest()"
                    >
                      Send Request
                    </button>
                    <tui-root>
                      <ng-container *ngIf="isLoadingRequest">
                        <tui-loader [inheritColor]="true"> </tui-loader>
                      </ng-container>
                    </tui-root>
                  </form>
                </div> -->
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fuild bg-light pt-5 pb-5 Small shadow feature-1">
    <div class="container py-2">
      <div class="text-center mb-4">
        <h1>Compare the Real Cost of College</h1>
      </div>
      <div class="row">
        <div class="col-md-3 text-center">
          <h2 class="text-black">
            <strong>100s</strong> of hours spent by families on colleges'
            websites
          </h2>
        </div>
        <div class="col-md-3 text-center">
          <h2>
            <strong>Cross-checking</strong> multiple tax forms to ascertain EFC
          </h2>
        </div>
        <div class="col-md-3 text-center">
          <h2 class="text-black">
            <strong>Dozens</strong> of forms to be filled to find out college
            costs
          </h2>
        </div>
        <div class="col-md-3 text-center">
          <h2 class="text-black">
            <strong>Weeks</strong> to collate the financial information from
            each college
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-2 pt-5">
    <div class="row feature-view d-flex align-items-center mb-4">
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/colleges-universities.jpg"
        />
      </div>
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">1500+ Colleges and Universities</h2>
          <p>
            Today, you would spend hours and hours to ascertain scholarships and
            aid available from different colleges for you. With Top5 you have
            access to pre-collated data from 1500+ colleges with more added
            every day, making the choice easier to make.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-4 pt-4">
    <div class="row feature-view d-flex align-items-center">
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">40+ Courses Supported</h2>
          <p>
            You could be keen to study physical education or you could be
            passionate about aeronautical engineering, you can select from over
            40+ courses offered at the institutions available in Top5Colleges.
          </p>
        </div>
      </div>
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/courses-supported.jpg"
          class="w-full"
        />
      </div>
    </div>
  </div>

  <div class="container mt-4 pt-4 mb-5">
    <div class="row feature-view d-flex align-items-center mt-5">
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/compare-award-letters.png"
          class="w-full"
        />
      </div>
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">Compare Award Letters</h2>
          <p>
            Already have Award letters from colleges, just upload them and let
            Top5Collleges use the proprietary AI technology to swift through the
            letters and give you tabulated information for comparison.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-4 pt-4 mb-5">
    <div class="row feature-view d-flex align-items-center">
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">Find the Out-of-Pocket Cost</h2>
          <p>
            The most difficult part about college tuition finance is finding the
            actual out-of-pocket cost of attending. With Top5Colleges this cost
            is discerned in big and bold on the results page for you to Choose
            Wisely!
          </p>
        </div>
      </div>
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/find-the-out-of-pocket-cost.jpg"
          class="w-full"
        />
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
